import React from "react"
import IconWithTooltipAndCustomBody from "../../../../components/molecules/IconWithTooltipAndCustomBody.molecule"
import CustomIconWithTooltipAndCustomBody from "../../../../components/molecules/CustomIconWithTooltipAndCustomBody.molecule"
import VacationDayVariantChip from "../../../../components/molecules/VacationDayVariantChip.molecule"
import {
  VACATION_DAY_TYPES,
  VACATION_DAY_TYPE_COPYS,
} from "../../../../consts/modules/vacations.consts"
import PropTypes from "prop-types"
import { Skeleton } from "../../../../components/atoms/misc/Skeleton.atom"
import useThemeContext from "../../../../hooks/contextConsumers/useThemeContext.hook"

export const VacationDaysValueTemplate = ({
  label,
  value,
  showZeroValue = false,
  labelTooltip,
  labelTooltipContent,
  labelTooltipPosition,
  labelTooltipIcon,
  showWarningBadge,
  loading,
  warningBadgeTooltipContent = undefined,
  warningBadgeTooltipPosition = "right",
  warningBadgeOnClick = () => {},
  tooltipOnClick = () => {}
}) => {
  const { theme } = useThemeContext()

const WarningIcon = ({ className = "" }) => (
  <i 
    className={`pi pi-exclamation-triangle ml-1 ${className}`}
    style={{
      color: showWarningBadge ? "var(--clr-danger)" : "var(--text-color)",
    }}
    onClick={warningBadgeOnClick}
  />
)

const getDayTypeChip = (label, theme) => {
  const labelToDayTypeMap = {
    [VACATION_DAY_TYPE_COPYS.BUCKET]: VACATION_DAY_TYPES.BUCKET,
    [VACATION_DAY_TYPE_COPYS.PLUS]: VACATION_DAY_TYPES.PLUS,
    [VACATION_DAY_TYPE_COPYS.EXTRA]: VACATION_DAY_TYPES.EXTRA,
    [VACATION_DAY_TYPE_COPYS.ACCORDED]: VACATION_DAY_TYPES.ACCORDED,
    [VACATION_DAY_TYPE_COPYS.APROBADOS]: VACATION_DAY_TYPES.APROBADOS,
    [VACATION_DAY_TYPE_COPYS.POR_APROBAR]: VACATION_DAY_TYPES.POR_APROBAR,
  }
  
  const dayType = labelToDayTypeMap[label]
  
  return dayType ? (
    <VacationDayVariantChip
      dayType={dayType}
      iconProps={
        label === VACATION_DAY_TYPE_COPYS.BUCKET && theme === "dark" ?
          { style: { color: "rgb(51, 56, 63)" } }
        : undefined
      }
    />
  ) : null
}


  return (
    <div className="value-with-label-template value-with-label-template--with-icon flex flex-1 flex-shrink-0 white-space-nowrap">
      <div className="flex flex-row align-items-center gap-2">
        {getDayTypeChip(label, theme)}
        <span className="label font-semibold text-base font-mulish">
          {label}
        </span>
      </div>
      <div className="flex flex-row align-items-center gap-1 counter-icon-container">
        <span className="value font-cairo font-semibold">
          {loading ?
            <Skeleton className="loading-skeleton" />
          : typeof value === "function" ?
            value()
          : value || (showZeroValue ? 0 : "")}
        </span>
        {showWarningBadge && (
          warningBadgeTooltipContent ?
            <CustomIconWithTooltipAndCustomBody
              tooltipBody={warningBadgeTooltipContent}
              position={warningBadgeTooltipPosition}
              CustomIcon={WarningIcon}
            />
          :
            <WarningIcon/>
        )}
        {labelTooltip && typeof labelTooltipIcon === "string" && (
          <IconWithTooltipAndCustomBody
            tooltipBody={labelTooltipContent}
            position={labelTooltipPosition}
            iconClassName={`${labelTooltipIcon} mx-1`}
            onClick={tooltipOnClick}
          />
        )}
        {labelTooltip && typeof labelTooltipIcon === "object" && (
          <CustomIconWithTooltipAndCustomBody
            tooltipBody={labelTooltipContent}
            position={labelTooltipPosition}
            CustomIcon={labelTooltipIcon}
            onClick={tooltipOnClick}
          />
        )}
      </div>
    </div>
  )
}

VacationDaysValueTemplate.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
    PropTypes.func,
  ]),
  labelTooltip: PropTypes.bool,
  labelTooltipContent: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  labelTooltipPosition: PropTypes.string,
  labelTooltipIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  showWarningBadge: PropTypes.bool,
  warningBadgeTooltipContent: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  loading: PropTypes.bool,
  showZeroValue: PropTypes.bool,
  warningBadgeTooltipPosition: PropTypes.string,
  warningBadgeOnClick: PropTypes.func
}
